import create from 'zustand';
import { ICreateProfile } from '../@types';
import { profileService } from '../services';
import { BankData } from '../types';

interface UserState {
  user: any;
  setUser: (user: any) => void;
  fetchUserProfile: () => Promise<void>;
  fetchBankData:()  => Promise<void>;
}

export const useUserStore = create<UserState>((set, get) => ({
  user: [],
  setUser: (user:ICreateProfile  ) => {
    console.log('User set:', user);
    set(() => ({ user }));
  },
  fetchUserProfile: async () => {
    try {
      const res = await profileService.get('/companies/profile');
      const userProfile = res.data;
      set({ user: userProfile });
    } catch (e: any) {
      console.log('Failed to fetch user profile:', e);
    }
  },
   fetchBankData: async () => {
    try {
      const res = await profileService.get('company/bank-accounts');
      const bankData: BankData = res.data;
      set((state) => ({ user: { ...state.user, bankData } }));
    } catch (e: any) {
      console.log('Failed to fetch bank data:', e);
    }
  },
}));